<ng-container *ngIf="options">
  <div class="canvas-renderer__wrapper" [class.one-page]="pages?.length == 1">
    <div class="canvas-renderer__pbi-content">
      @if (readyToRender) {
        @if (options.contentType == CanvasRendererContentType.Dashboard) {
          <dashboard-embed [print]="true"
                           [dashboardId]="dashboardId" 
                           [dashboardDto]="dashboard"
                           [pageHeader]="pageHeader"
                           [pageFooter]="branding.includeHeader ? pageFooter : null"
                           [pageHeight]="branding.includeFooter ? pageHeight : null"
                           [pageHeaderHeight]="'0.85in'"
                           [pageFooterHeight]="'0.85in'"
                           (dashboardRendered)="onContentRendered()"
                           [locale]="locale()">
          </dashboard-embed>
        }
        @else if(options.contentType == CanvasRendererContentType.Visual) {
          <visual-embed [print]="true"
                        [visualId]="visualId"
                        [visualDto]="visual"
                        [pageHeader]="branding.includeHeader ? pageHeader : null"
                        [pageFooter]="branding.includeFooter ? pageFooter : null"
                        [pageHeight]="pageHeight"
                        (visualRendered)="onContentRendered()"
                        [locale]="locale()">
          </visual-embed>
        }
      }
    </div>

    <ng-template #pageHeader let-pageIndex="pageIndex"> 
      @if (branding.includeHeader) {
        <div class="canvas-renderer__page-header">
          <div class="d-inline-block">
            <ng-container *ngIf="branding.name">
              @if (branding.namePrefix) {
                <span class="c-blue" style="margin-right: 0.2cm">{{ branding.namePrefix }}</span>
              }
              <span class="bold">{{ branding.name }}</span>
            </ng-container>
          </div>
          <div class="d-inline-block">
            @if (branding.headerLogoUrl) {
              <img src="{{ branding.headerLogoUrl }}" class="canvas-renderer__logo" />
            }
            @else {
              <span>{{ branding.orgName }}</span>
            }
          </div>
        </div>
      }
    </ng-template>

    <ng-template #pageFooter let-pageIndex="pageIndex">
      @if (branding.includeFooter) {
        <div class="canvas-renderer__page-footer">
          <div class="d-flex align-items-center h-100p">
            @if (branding.showPageNumbers && pages?.length) {
              <span class="c-blue">Page {{ pageIndex + 1 }} of {{ pages.length }}</span>
            }
          </div>
          <div class="d-flex align-items-center h-100p">
            @if (branding.exportedAtUTC) {
              <span class="c-blue" style="margin-right: 0.2cm">Exported:</span>
              <span>
                {{
                  branding.exportedAtUTC
                    | dateWithTimezone
                      : localisationService.CUSTOM_DATE_FORMATS.mediumDateTimeNoSeconds
                      : { iana: branding.exportedAtTimeZone }
                      : branding.exportedAtLocal
                }}
              </span>
            }
          </div>
          <div class="d-flex align-items-center h-100p">
            <img class="footer__brand-image" src="/assets/img/trg-logo.svg" alt="TRG Screen" />
          </div>
        </div>
      }
    </ng-template>
  </div>
</ng-container>
